import React from 'react';
import cx from 'classnames';

export default function QuizLayout(props) {

  const { top, bottom, left, right } = props;

  const layoutClasses = cx({
    'quiz-layout': true,
    'vertical': top && bottom,
    'horizontal': left && right,
  });

  return (
    <div className={layoutClasses}>
      {top && <div className="top">{top}</div>}
      {left && <div className="left">{left}</div>}
      {right && <div className="right">{right}</div>}
      {bottom && <div className="bottom">{bottom}</div>}
    </div>
  );
}